import { useReactiveVar } from '@apollo/client'
import { Box, Flex, Text } from '@radix-ui/themes'
import { DataTestIDs } from 'shared/constants'
import { balanceVar } from 'shared/store/balance-store'
import { ApprovedBalanceValue } from './approved-balance-value'
import styles from '../approved-balance.module.scss'

export const ApprovedBalanceAmount = () => {
  const balance = useReactiveVar(balanceVar)

  return (
    <Box className={styles.approvedAmountBox}>
      <Flex
        direction={'column'}
        className={styles.approvedAmountContent}
        gap={'2'}
      >
        <Text
          size={'2'}
          weight={'medium'}
          color='gray'
          mb={'2'}
        >
          Wallet: SOL for fees · USDT for play
        </Text>

        <Flex
          gap={'2'}
          mt={'2'}
          wrap={'wrap'}
        >
          <Flex className={styles.balanceWrap}>
            <ApprovedBalanceValue
              title={'SOL (native)'}
              value={balance.nativeBalance}
              dataTestID={DataTestIDs.treasureWalletValue}
              width={'max-content'}
              p={'3'}
            />
          </Flex>

          <Flex className={styles.balanceWrap}>
            <ApprovedBalanceValue
              title={'USDT (wallet)'}
              value={balance.tokenBalance}
              dataTestID={DataTestIDs.treasureApprovedValue}
              width={'max-content'}
              p={'3'}
            />
          </Flex>

          <ApprovedBalanceValue
            title={'USDT (treasury)'}
            value={balance.tokenDeposited}
            dataTestID={DataTestIDs.treasureTreasureValue}
            width={'100%'}
            className={styles.balanceWrap}
            p={'3'}
          />
        </Flex>
      </Flex>
    </Box>
  )
}
